import CountCell from 'components/CountCell';
import ROUTE_NAMES from 'setup/Routing/routeNames';
import type { ManagedTeamsType } from '../..';

interface CellProps {
  rowData: ManagedTeamsType;
}

export default function PlatformAccountsCountCell({
  rowData: { id, totals, oemSegment },
}: CellProps) {
  return (
    <CountCell
      count={totals?.platformAccounts}
      sectionPath={ROUTE_NAMES.admin.managementAccounts}
      pageParams={{
        tab: 'accounts',
        teamIds: [id],
        oemSegmentIds: oemSegment?.id ? [oemSegment?.id] : [],
        accountIds: [],
        depotIds: [],
      }}
    />
  );
}
